const FILTER_TRIGGER_SELECTOR =
  '[aria-controls="filters-drawer"], .kervelan-collection__filter-trigger, .facets-toggle__button';

let runtimePromise;
let runtimeReady = false;

const ensureFilterRuntime = () => {
  if (!runtimePromise) {
    runtimePromise = Promise.all([import('@theme/scroll-hint'), import('@theme/theme-drawer')])
      .then(() => {
        runtimeReady = true;
      })
      .catch((error) => {
        runtimePromise = undefined;
        throw error;
      });
  }

  return runtimePromise;
};

const getFilterTrigger = (event) => {
  const target = event.target;
  return target instanceof Element ? target.closest(FILTER_TRIGGER_SELECTOR) : null;
};

const warmFromIntent = (event) => {
  if (!getFilterTrigger(event)) return;
  ensureFilterRuntime().catch(() => {});
};

for (const eventName of ['pointerover', 'focusin', 'touchstart', 'pointerdown']) {
  document.addEventListener(eventName, warmFromIntent, {
    capture: true,
    passive: eventName !== 'focusin',
  });
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = getFilterTrigger(event);
    if (!trigger || runtimeReady) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    ensureFilterRuntime()
      .then(() => trigger.click())
      .catch(() => {
        const href = trigger instanceof HTMLAnchorElement ? trigger.href : '';
        if (href) window.location.assign(href);
      });
  },
  true
);

if (window.Shopify?.designMode) {
  ensureFilterRuntime().catch(() => {});
}
